import * as _ from 'lodash';

export function debounce<T extends (...args: any[]) => any>(fn : T, wait : number = 0) : T & _.Cancelable {
    return _.debounce<T>(fn, wait);
}